import { api } from './apiService.js';
// import occasions from '../json/occasions.json'; // فایل مناسبت‌ها

function populateQuote() {
    const quoteTextElement = document.getElementById('dash-quote-text');
    const quoteAuthorElement = document.getElementById('dash-quote-author');

    if (!quoteTextElement || !quoteAuthorElement) return;

    api.generalGetQuote()
        .then(quote => {
            quoteTextElement.textContent = quote.quote;
            quoteAuthorElement.textContent = quote.author;
        })
        .catch(error => {
            quoteTextElement.textContent = "با تجربه انجامش بده.";
            quoteAuthorElement.textContent = "ویکو";
        });
}

function populateCalendar() {
    const calendarCard = document.getElementById('dash-cal-card'); // کارت تقویم
    const weekdayElement = document.getElementById('dash-cal-weekday');
    const jalaliElement = document.getElementById('dash-cal-jalali');
    const gregorianElement = document.getElementById('dash-cal-gregorian');
    const eventsElement = document.getElementById('dash-cal-events');

    if (!weekdayElement) return;

    const now = new Date();

    const weekday = now.toLocaleDateString('fa-IR', { weekday: 'long' });
    const jalaliDate = now.toLocaleDateString('fa-IR', { day: 'numeric', month: 'long'  , year: 'numeric' });
    const gregorianDate = now.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });

    const jalaliMonth = parseInt(now.toLocaleDateString('fa-IR-u-nu-latn', { month: 'numeric' }));

    // const jalaliMonth = 10;

    let seasonClass = 'bg-vico-winter';
    if (jalaliMonth >= 1 && jalaliMonth <= 3) {
        seasonClass = 'bg-vico-spring';
    } else if (jalaliMonth >= 4 && jalaliMonth <= 6) {
        seasonClass = 'bg-vico-summer';
    } else if (jalaliMonth >= 7 && jalaliMonth <= 9) {
        seasonClass = 'bg-vico-autumn';
    }
    calendarCard.classList.add(seasonClass);

    weekdayElement.textContent = weekday;
    jalaliElement.textContent = jalaliDate;
    gregorianElement.textContent = gregorianDate;
    eventsElement.innerHTML = '';
    api.generalGetEvents()
        .then(result => {
            if (result && result.length > 0) {
                eventsElement.innerHTML = result.join('<br>');
            }
        })
        .catch(error => {
            eventsElement.innerHTML = '';
        });
}

export function initDashboardPage() {
    populateQuote();
    populateCalendar();
}
